import { createContext, useContext } from 'react';
import { AuthContextValue } from './AuthProvider.types';

export const AuthContext = createContext<AuthContextValue>({
  tokenExpired: false,
  setTokenExpired: () => {},
  session: null,
  setSession: () => {},
});

export default function useAuthContext() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
